import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function CheckIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.1757 5.26267C20.5828 5.63586 20.6103 6.26843 20.2372 6.67555L9.23715 18.6756C9.05285 18.8766 8.79441 18.9937 8.52172 18.9996C8.24903 19.0055 7.98576 18.8998 7.79289 18.7069L3.29289 14.2069C2.90237 13.8164 2.90237 13.1832 3.29289 12.7927C3.68342 12.4022 4.31658 12.4022 4.70711 12.7927L8.46859 16.5542L18.7628 5.3241C19.136 4.91698 19.7686 4.88947 20.1757 5.26267Z"
				fill="currentColor"
			/>
		</svg>
	);
}

CheckIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default CheckIcon;
